import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import JsonLd from '@/components/feature/JsonLd';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryNavSection from './components/CategoryNavSection';
import HotRankingSection from './components/HotRankingSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import { useSEO } from '@/hooks/useSEO';
import { homepageFAQ, articles } from '@/mocks/articles';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '火影同人本子·精选创作合集',
    url: 'https://huoying-tongren.com/',
    description: '火影同人本子是火影忍者粉丝二次创作的重要表达形式，涵盖漫画、小说、画册等多种形式。汇聚优质创作资源、投稿指南与同人活动信息。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://huoying-tongren.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '火影同人本子',
    url: 'https://huoying-tongren.com/',
    description: '火影同人本子是火影忍者粉丝二次创作的重要表达形式，涵盖漫画、小说、画册等多种形式。连接同人作者与读者，让每一份热爱都被看见。',
    foundingDate: '2024',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: homepageFAQ.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  },
];

export default function Home() {
  const latestArticle = articles[0];

  useSEO(
    '火影同人本子·精选创作合集 | 火影忍者同人漫画小说画集',
    '火影同人本子是火影忍者粉丝二次创作的重要表达形式，涵盖漫画、小说、画册等多种形式。本页汇聚优质火影同人本子创作资源、投稿指南与同人活动信息，帮助同人作者与读者发现更多精彩内容。',
    '火影同人本子,火影忍者同人漫画,火影同人创作,火影CP同人,火影同人小说,火影同人画集,火影同人活动',
    'https://huoying-tongren.com/',
    'website',
    latestArticle?.coverImage || '',
  );

  return (
    <>
      <ScrollToTop />
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategoryNavSection />
        <HotRankingSection />
        <LatestSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}